<template>
    <div>
        <span>
            <span @click="showDetail">详情</span>
            <Modal
                v-model="isShow"
                title="数据详情"
                @on-cancel="cancel"
                @on-ok="ok">
                <Tabs>
                <TabPane label="数据">
                    <div>
                        <div style="color:red">{{errorInfo}}</div>
                        <Form :label-width="80">
                            <FormItem label="URL">
                                <Input type="text" v-model="url" placeholder="URL..." :width="200"></Input>
                            </FormItem>
                        </Form>
                        {{dataStr}}
                    </div>
                </TabPane>
                <TabPane label="格式化">
                    <TransformerEditor :transformers="transformers" :allFunctionsMap="allFunctionsMap" :orginData="data"></TransformerEditor>
                </TabPane>
            </Tabs>

                
            </Modal>
        </span>
    </div>
</template>
<script>
import * as restRequest from '@/runtime-components/data-builder/request/rest-request';
import TransformerEditor from '../../function-editor/index';
export default {
    props:['value', 'isDefault', 'allFunctionsMap'],
    components:{TransformerEditor},
    data() {
        return {
            isShow:false,
            url:null,
            transformers:[],
            dataStr:'',
            errorInfo:'',
            data:[]
        }
    },
    mounted() {
        if(this.value){
            this.transformers = this.value.transformers||[];
            if(this.value.request){
                this.url = this.value.request.url;
            }
        }
    },
    watch:{
        value:{
             handler(){
                 try {
                     if(this.isDefault){
                        this.data = this.value.data;
                        this.dataStr = JSON.stringify(this.value.data);
                    }else{
                        this.url = this.value.request.url;
                        this.transformers = this.value.transformers;
                    }
                 } catch (e) {
                     this.errorInfo = e.message;
                 }
            },
            immediate:true
        },

        url:{
            handler(){
                this.errorInfo = '';
                restRequest.fetch({request:{url:this.url}}).then(data=>{
                    this.data = data;
                    this.dataStr = JSON.stringify(data);
                }).catch(e=>{
                    if(Error.isError(e)){
                        this.errorInfo = e.message;
                    }
                });
            },
            immediate:true
        }
    },
    methods: {
        showDetail(){
            this.isShow = true;
        },

        ok(){
            let url = this.url;
            this.$emit('input', {request:{url:url}, transformers:this.transformers});
            this.$emit('save');
        },

        cancel(){
            this.dataConfig = Object.assign({}, this.value);
        }
    },

}
</script>